import type { EpcScheduleTaskRow } from '../../types/scheduleTask';

function simpleHash(s: string): string {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h).toString(36);
}

/**
 * Stable key for schedule task discussion threads. Prefer MS Project `uniqueId`;
 * otherwise fall back to id or a deterministic hash of outline + WBS + name.
 */
export function epcScheduleTaskStableKey(task: EpcScheduleTaskRow): string {
  const uid = task.uniqueId;
  if (uid != null && uid !== '') {
    const n = Number(uid);
    if (Number.isFinite(n)) return `u${n}`;
  }
  const idRaw = task.id ?? task.Id;
  if (idRaw != null && String(idRaw).trim() !== '') {
    const s = String(idRaw)
      .trim()
      .replace(/[^a-zA-Z0-9_-]/g, '_')
      .slice(0, 80);
    if (s) return `i${s}`;
  }
  const wbs = String(task.wbs ?? '').trim();
  const name = String(task.name ?? '').trim();
  const ol = String(task.outlineLevel ?? '');
  const h = simpleHash(`${ol}\0${wbs}\0${name}`);
  return `f${ol}-${h}`;
}
